export class DeliveryPointOfServiceModel { }